import { render, staticRenderFns } from "./chatbot-message.vue?vue&type=template&id=c344ea4e"
import script from "./chatbot-message.vue?vue&type=script&lang=js"
export * from "./chatbot-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports